import type { Signal } from 'typed-signals';
import type { Container } from 'pixi.js';

export enum PageType {
  Home = 'Home',
  Store = 'Store',
  Tournament = 'Tournament',
  Settings = 'Settings',
}

export interface MenuIcon extends Container {
  onVisibilityChanged: Signal<(visible: boolean) => void>;
  isVisible(): boolean;
}

export interface IObservableValue<T> {
  getValue(): T;
  updateValue(value: Partial<T>): void;
  addChangeHandler(lifeCycleObject: Container, callback: (newValue: T) => void, skipInitCall?: boolean): void;
}
